/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Maybe } from '@irian-ro/util-functions';

export class PointDtoModel {

  latitude: Maybe<number> | undefined = undefined;

  longitude: Maybe<number> | undefined = undefined;

  static asPointDto(location: google.maps.LatLng): PointDtoModel{
    const pointDto: PointDtoModel = new PointDtoModel();
    pointDto.latitude = location.lat();
    pointDto.longitude = location.lng();

    return pointDto;
  }
}
